const data = [
    {
      id: 1,
      question: "Who is the chairman of TCS ?",
      answers: [
        {
          text: "Pradeep Kumar",
          correct: false,
        },
        {
          text: "Natarajan Chandrasekaran",
          correct: true,
        },
        {
          text: "OP Bhatt",
          correct: false,
        },
        {
          text: "Sathyamurthi",
          correct: false,
        },
      ],
    },
    {
      id: 2,
      question: "In which year was TCS founded ?",
      answers: [
        {
          text: "1868",
          correct: true,
        },
        {
          text: "1969",
          correct: false,
        },
        {
          text: "1966",
          correct: false,
        },
        {
          text: "1967",
          correct: false,
        },
      ],
    },
    {
      id: 3,
      question: "Who is CEO of TCS ?",
      answers: [
        {
          text: "Deep Singh",
          correct: false,
        },
        {
          text: "Natarajan Chandrasekaran",
          correct: false,
        },
        {
          text: "Denzel Washington",
          correct: false,
        },
        {
          text: "Rajesh Gopinathan",
          correct: true,
        },
      ],
    },

    {
      id: 4,
      question: "Which of these company is NOT owned by Tata ?",
      answers: [
        {
          text: "Tata Motor",
          correct: false,
        },
        {
          text: "Tata Steel",
          correct: false,
        },
        {
          text: "Tata Power",
          correct: false,
        },
        {
          text: "Tata Tobacco",
          correct: true,
        },
      ],
    },

    {
      id: 5,
      question: "In how many countries does TCS operates ?",
      answers: [
        {
          text: "43",
          correct: false,
        },
        {
          text: "44",
          correct: false,
        },
        {
          text: "45",
          correct: false,
        },
        {
          text: "46",
          correct: true,
        },
      ],
    },

    {
      id: 6,
      question: "Highest share price of TCS ?",
      answers: [
        {
          text: "3991",
          correct: false,
        },
        {
          text: "3990",
          correct: true,
        },
        {
          text: "3992",
          correct: false,
        },
        {
          text: "3993",
          correct: false,
        },
      ],
    },

    {
      id: 7,
      question: "Which of the following key takes referenec from primary key in DBMS ?",
      answers: [
        {
          text: "Candidate key",
          correct: false,
        },
        {
          text: "Composite Key",
          correct: false,
        },
        {
          text: "Foreign Key",
          correct: true,
        },
        {
          text: "Suoer Key",
          correct: false,
        },
      ],
    },

    {
      id: 8,
      question: "Who is the CM of Karnataka ?",
      answers: [
        {
          text: "Yedurappa",
          correct: false,
        },
        {
          text: "Sidharamya Gowda",
          correct: false,
        },
        {
          text: "Munirathna",
          correct: false,
        },
        {
          text: "Basvaraju Bommai",
          correct: true,
        },
      ],
    },

    {
      id: 9,
      question: "Time Complexity of Binary Search Algorithm is  ?",
      answers: [
        {
          text: "O(logn)",
          correct: true,
        },
        {
          text: "O(n)",
          correct: false,
        },
        {
          text: "O(n^2)",
          correct: false,
        },
        {
          text: "O(2^n)",
          correct: false,
        },
      ],
    },

    {
      id: 10,
      question: "Who developed C++ ?",
      answers: [
        {
          text: "James Goslin",
          correct: false,
        },
        {
          text: "Guido Van Rossum",
          correct: false,
        },
        {
          text: "Denis Retchie",
          correct: false,
        },
        {
          text: "Bjarne Stroustrup",
          correct: true,
        },
      ],
    },

    {
      id: 11,
      question: "1 bytes contains how many bits ?",
      answers: [
        {
          text: "6",
          correct: false,
        },
        {
          text: "8",
          correct: true,
        },
        {
          text: "2",
          correct: false,
        },
        {
          text: "4",
          correct: false,
        },
      ],
    },

    {
      id: 12,
      question: "Who is CEO of TCS ?",
      answers: [
        {
          text: "Deep Singh",
          correct: false,
        },
        {
          text: "Natarajan Chandrasekaran",
          correct: false,
        },
        {
          text: "Denzel Washington",
          correct: false,
        },
        {
          text: "Rajesh Gopinathan",
          correct: true,
        },
      ],
    },

    {
      id: 13,
      question: "A new hiring program by TCS ?",
      answers: [
        {
          text: "Graduate Hiring Program",
          correct: false,
        },
        {
          text: "TCS Hiring Program",
          correct: false,
        },
        {
          text: "Smart Hiring Program",
          correct: true,
        },
        {
          text: "Campus Hiring Program",
          correct: false,
        },
      ],
    },

    {
      id: 14,
      question: "Rolex is a company that specializes in what type of product?",
      answers: [
        {
          text: "Phone",
          correct: false,
        },
        {
          text: "Watches",
          correct: true,
        },
        {
          text: "Food",
          correct: false,
        },
        {
          text: "Cosmetic",
          correct: false,
        },
      ],
    },

    {
      id: 15,
      question: "When did the website `Facebook` launch?",
      answers: [
        {
          text: "2004",
          correct: true,
        },
        {
          text: "2005",
          correct: false,
        },
        {
          text: "2006",
          correct: false,
        },
        {
          text: "2007",
          correct: false,
        },
      ],
    },
  ];
export default data;